import Cookies from 'js-cookie';

const getWorkspaceArtifacts = async ({ commit, rootGetters, dispatch }, payload) => {
  commit('SET_IS_ARTIFACT_LIST_LOADING', true);
  try {
    const customer = rootGetters['customer/CUSTOMER'];
    const selected_customer = rootGetters['customer/SELECTED_CUSTOMER'];
    const data = {
      ...payload,
      userId: Cookies.get('userId'),
      customer_id: customer.customer_id,
    };

    if (customer.customer_id === 0) {
      data.customer_id = selected_customer.customer_id;
    }
    data.page ??= 0;
    data.limit ??= 6;

    let url = `/proxy/ai/workspaces/${payload.workspaceId}/artifacts?page=${data.page}&customer_id=${
      data.customer_id
    }&limit=${data.limit}`;
    url += `&userId=${Cookies.get('userId')}`;

    const response = await window.axios.get(url, data);
    if (response && response.data.success) {
      if (payload.push) {
        commit('PUSH_ARTIFACT_LIST', response.data.artifacts);
      } else {
        commit('SET_ARTIFACT_LIST', response.data.artifacts);
      }
    } else {
      throw response.data;
    }
  } catch (error) {
    dispatch('notifications/setError', error.message, { root: true });
  } finally {
    commit('SET_IS_ARTIFACT_LIST_LOADING', false);
  }
};

export default getWorkspaceArtifacts;
